const prefixCls = 'web.menu.';

export const localesPermission = {
  // 权限管理相关
  [prefixCls + 'permission.title']: {
    zh_CN: '权限管理',
    en_GB: 'Permission Management',
  },
  [prefixCls + 'permission.search.placeholder']: {
    zh_CN: '请输入名称搜索',
    en_GB: 'Search by name',
  },
  [prefixCls + 'permission.button.create']: {
    zh_CN: '新建',
    en_GB: 'Create',
  },
  [prefixCls + 'permission.button.search']: {
    zh_CN: '搜索',
    en_GB: 'Search',
  },

  // 表格列
  [prefixCls + 'permission.table.column.id']: {
    zh_CN: 'ID',
    en_GB: 'ID',
  },
  [prefixCls + 'permission.table.column.name']: {
    zh_CN: '名称',
    en_GB: 'Name',
  },
  [prefixCls + 'permission.table.column.url']: {
    zh_CN: 'url',
    en_GB: 'URL',
  },
  [prefixCls + 'permission.table.column.actions']: {
    zh_CN: '操作',
    en_GB: 'Actions',
  },

  // 操作按钮
  [prefixCls + 'permission.action.edit']: {
    zh_CN: '编辑',
    en_GB: 'Edit',
  },
  [prefixCls + 'permission.action.delete']: {
    zh_CN: '删除',
    en_GB: 'Delete',
  },

  // 表单相关
  [prefixCls + 'permission.form.title.create']: {
    zh_CN: '新增权限',
    en_GB: 'Create Permission',
  },
  [prefixCls + 'permission.form.title.edit']: {
    zh_CN: '编辑权限',
    en_GB: 'Edit Permission',
  },
  [prefixCls + 'permission.form.label.name']: {
    zh_CN: '名称',
    en_GB: 'Name',
  },
  [prefixCls + 'permission.form.placeholder.name']: {
    zh_CN: '请输入名称',
    en_GB: 'Please enter name',
  },
  [prefixCls + 'permission.form.label.url']: {
    zh_CN: 'URL',
    en_GB: 'URL',
  },
  [prefixCls + 'permission.form.placeholder.url']: {
    zh_CN: '请输入URL',
    en_GB: 'Please enter URL',
  },
  [prefixCls + 'permission.form.button.create']: {
    zh_CN: '创建',
    en_GB: 'Create',
  },
  [prefixCls + 'permission.form.button.update']: {
    zh_CN: '更新',
    en_GB: 'Update',
  },
  [prefixCls + 'permission.form.button.cancel']: {
    zh_CN: '取消',
    en_GB: 'Cancel',
  },

  // 表单验证消息
  [prefixCls + 'permission.form.validation.nameRequired']: {
    zh_CN: '请输入名称',
    en_GB: 'Please enter name',
  },
  [prefixCls + 'permission.form.validation.urlRequired']: {
    zh_CN: '请输入URL',
    en_GB: 'Please enter URL',
  },

  // 通用消息
  [prefixCls + 'permission.message.createSuccess']: {
    zh_CN: '创建成功',
    en_GB: 'Created successfully',
  },
  [prefixCls + 'permission.message.updateSuccess']: {
    zh_CN: '更新成功',
    en_GB: 'Updated successfully',
  },
  [prefixCls + 'permission.message.deleteSuccess']: {
    zh_CN: '删除成功',
    en_GB: 'Deleted successfully',
  },
  [prefixCls + 'permission.message.confirmDelete']: {
    zh_CN: '确定要删除这个权限吗？',
    en_GB: 'Are you sure you want to delete this permission?',
  },
};
